module.exports = __webpack_public_path__ + "static/img/yz_indicator.png";